/**
 * Make sure value is an array of values and wraps it if needed
 * @param item
 * @returns {*[]}
 */
export default function array(value) {
  return (value.constructor === Array ? value : [value])
}
